import axios from "../../config/axiosConfig";
import { CREATE_INDUSTRY_TYPE, GET_INDUSTRY_TYPES, INDUSTRY_TYPE_REQUEST, DELETE_INDUSTRY_TYPE, UPDATE_INDUSTRY_TYPE, INDUSTRY_TYPE_REQUEST_FAILURE } from "../types";

export const getIndustryTypes = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: INDUSTRY_TYPE_REQUEST });
      const { auth } = getState();
      return axios.get("/industry-type/getAll", {
        params: { userId: auth.superUser?.id },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_INDUSTRY_TYPES, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: INDUSTRY_TYPE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: INDUSTRY_TYPE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createIndustryType = (industryType) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: INDUSTRY_TYPE_REQUEST });
      return axios.post("/industry-type/add", industryType,
        { params: { userId: auth.superUser?.id }}).then((response) => {
          if (response.data) {
            dispatch({ type: CREATE_INDUSTRY_TYPE, payload: response.data });
          } else {
            dispatch({
              type: INDUSTRY_TYPE_REQUEST_FAILURE,
              error: "Industry type create failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: INDUSTRY_TYPE_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: INDUSTRY_TYPE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateIndustryType = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: INDUSTRY_TYPE_REQUEST });
      const { auth } = getState();
      return axios.put("/industry-type/update", { id, data }, { params: { userId: auth.superUser?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_INDUSTRY_TYPE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: INDUSTRY_TYPE_REQUEST_FAILURE,
            error: "Industry type update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: INDUSTRY_TYPE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: INDUSTRY_TYPE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteIndustryType = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: INDUSTRY_TYPE_REQUEST });
      return axios.delete(`/industry-type/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_INDUSTRY_TYPE, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: INDUSTRY_TYPE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: INDUSTRY_TYPE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
